import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FarmSettingsModuleState } from '../../models/farm-settings.model';

export const getFarmSettingsModuleState =
  createFeatureSelector<FarmSettingsModuleState>('farmSettingsModule');
export const getCurrentFarmSettings = createSelector(getFarmSettingsModuleState, (state) => state);
